// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditStep_deleteButton__3f85k"};